import React, { useEffect, useState } from 'react';
import styles from './EcsPortal.module.scss';
import Campaigns from './Campaigns';
import EcsFaqs from './EcsFaqs';
import TrackCompetitors from './TrackCompetitors/TrackCompetitors';
import { getEcsDetails } from '../../api';
import { DataShimmer, Helpfull } from '../common';
import WithCsportalAuth from '../../hooks/WithCsportalAuth';
import FaqWrapper from '../common/FaqWrapper';
import useAlert from '../../hooks/useAlert';
import { getContractTypeVal, getProjectId } from '../../lib/common';
import { useLocalStorage } from '../../hooks';
import NoDataView from '../../pages/NoDataView';

function EcsHome() {
  const [ecsdetails, setEcsdetails] = useState({});
  const [campaigndetails, setCampaigndetails] = useState([]);
  const [redirectUrl, setRedirectUrl] = useState({});
  const [faqdetails, setFaqdetails] = useState([]);
  const [loader, setLoader] = useState(true);
  const [noDataFound, setNoDataFound] = useState('No Data Found for ECS');
  const [setAlert] = useAlert();
  const projectId = getProjectId();
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const contractVal = getContractTypeVal(projectId);

  const getAllEcsDetails = async () => {
    const commonParams = {
      backUrl: encodeURI(window.location.href),
      projectId,
    };
    let params = {};
    if (projectId === 'csportal') {
      params = {
        ...commonParams,
        pid: selectedBusiness.parentid,
        docid: selectedBusiness.docid,
        city: selectedBusiness.data_city,
        shortUrl: selectedBusiness.shorturl,
      };
    } else {
      params = {
        ...commonParams,
        mobile: profile?.mobile || '',
        pid: selectedBusinessGenio?.parentId || '',
        docid: selectedBusinessGenio?.docId || '',
        city: selectedBusinessGenio?.city ? encodeURIComponent(selectedBusinessGenio?.city) : '',
        shortUrl: selectedBusinessGenio?.shorturl || '',
      };
    }
    const res = await getEcsDetails(params);
    const data = res?.result || {};
    if (res) {
      setLoader(false);
    }
    if (res.errorCode === 0) {
      if (data.reactivationmessage) {
        setAlert({
          message: data?.reactivationmessage,
          status: true,
        });
      }

      setEcsdetails(data.ecsdetails);
      setCampaigndetails(data.campaigndetails);
      if (data.campaigndetails.length > 0) setNoDataFound('');
      else setNoDataFound('No Data Found for ECS');
      setFaqdetails(data.faqdetails);
      setRedirectUrl(data.redirectUrl);
    } else {
      setNoDataFound('No Data Found for ECS');
    }
  };
  useEffect(() => {
    getAllEcsDetails();
  }, []);
  const hasDocId = projectId === 'csportal' ? selectedBusiness?.docid || '' : selectedBusinessGenio?.docId || '';
  return (
    <div>
      {loader ? (
        <DataShimmer loader={loader} id="ecsfaq" />
      ) : (
        <>
          {!noDataFound ? (
            <>
              <div className={`${styles.bannerbox} `}>
                <div className={`${styles.banner_text} pt-5 pb-20 pl-15 pr-15`} />
              </div>
              <div className="p-20 pt-0">
                {/* Heading */}
                <div className={`${styles.Heading}`}>
                  <>
                    <div className={`${styles.Title} font16 fw700 color111`}>ECS Details</div>
                    <div className={`${styles.HeadBtnBox}`}>
                      <div
                        className={`${styles.StatusButton} ${
                          styles[ecsdetails && ecsdetails?.status && ecsdetails?.status?.trim()]
                        } ml-12`}
                      >
                        <div className={`${styles.Active__Icon} csicon`} />
                        <div className={`${styles.StatusButton__Text} font12 fw600 pl-4`}>
                          {ecsdetails && ecsdetails?.status}
                        </div>
                      </div>
                    </div>
                  </>
                </div>
                {/* Heading */}

                {/* Status Box */}
                <div className={`${styles.StatusBox} mt-20`}>
                  <div className={`${styles.StatusTopBar}`}>
                    <div className={`${styles.StatusColumn}`}>
                      <div className={`${styles.Status__Lable} font12 fw500 color777`}>Amount</div>
                      <div className={`${styles.Status__LabelText} font14 fw600 color111 mt-2`}>
                        {ecsdetails && ecsdetails.amount}
                      </div>
                    </div>
                    <div className={`${styles.StatusColumn}`}>
                      <div className={`${styles.Status__Lable} font12 fw500 color777`}>Next Installment</div>
                      <div className={`${styles.Status__LabelText} font14 fw600 color111 mt-2`}>
                        {ecsdetails && ecsdetails.nextInstallment}
                      </div>
                    </div>
                    <div className={`${styles.StatusColumn}`}>
                      <div className={`${styles.Status__Lable} font12 fw500 color777`}>Frequency</div>
                      <div className={`${styles.Status__LabelText} font14 fw600 color111 mt-2`}>
                        {ecsdetails && ecsdetails.frequency}
                      </div>
                    </div>
                  </div>

                  {campaigndetails && campaigndetails.length > 0 && (
                    <>
                      <div className="font12 fw500 color777 mt-15">Campaigns</div>
                      <Campaigns campaigndetails={campaigndetails} />
                    </>
                  )}
                </div>
                {/* Status Box */}
              </div>
              {faqdetails && Object.keys(faqdetails).length > 0 && (
                <EcsFaqs
                  getAllEcsDetails={getAllEcsDetails}
                  faqdetails={faqdetails}
                  campaigndetails={campaigndetails}
                  status={ecsdetails.status}
                  amount={ecsdetails.amount}
                  ecsdetails={ecsdetails}
                  redirectUrl={redirectUrl}
                  projectId={projectId}
                />
              )}
              {ecsdetails && ecsdetails?.status?.toLowerCase() === 'cancelled' && (
                <TrackCompetitors redirectUrl={redirectUrl} />
              )}
              <Helpfull redirectkey="ecs" />
            </>
          ) : (
            <>
              {hasDocId && contractVal !== 'free' ? (
                <h2 style={{ textAlign: 'center', marginTop: '30vh' }}>{noDataFound}</h2>
              ) : (
                <NoDataView pageName="ECS" />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}
export default WithCsportalAuth(FaqWrapper(EcsHome));
